import React, {
  useEffect, useState
} from 'react'

import Form from '@/molecules/Form'

import { StyledSearch } from './styles'

const Search = (props) => {
  const [formData, setFormData] = useState(props.form)
  const a11yId = 'search_field'

  useEffect(() => {
    if (window.location.search) {
      const formCloned = structuredClone(props.form)
      const { form } = formCloned
      const { initialValues } = form


      for (const [key, value] of new URLSearchParams(window.location.search).entries()) {
        if (!(key in initialValues)) continue
        initialValues[key] = value
      }

      setFormData(formCloned)
    }
  }, [])

  return (
    <StyledSearch>
      {/*
        The ID is sent down the chain
        and is set on the search field.

        By the nature of the project's dynamic forms,
        all fields can receive the prop; but only the ones
        that set a value (like in this case) will have it enabled.
      */}
      <label htmlFor={a11yId}>Cerca</label>

      <Form {...formData} {...{ a11yId }} />
    </StyledSearch>
  )
}

export default Search
